<template lang="pug">
  aiq-tooltip(effect="dark"
              placement="top"
              :disabled="!showTooltip"
              :content="displayValue")
    component.noneditable-value(:is="isHttpUrl ? 'a' : 'div'"
                                :href="isHttpUrl ? displayValue : null"
                                :target="isHttpUrl ? '_blank' : null"
                                :rel="isHttpUrl ? 'noopener noreferrer' : null")
      | {{ displayValue }}
</template>

<script>
const TRUNCATE_TOOLTIP_THRESHOLD = 30;

export default {
  props: {
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
  },
  computed: {
    displayValue() {
      if (this.value === undefined || this.value === null) return '';
      return String(this.value);
    },
    isHttpUrl() {
      const value = this.displayValue.trim();
      if (!value) return false;
      try {
        const url = new URL(value);
        return url.protocol === 'http:' || url.protocol === 'https:';
      } catch (err) {
        return false;
      }
    },
    showTooltip() {
      return this.displayValue.length > TRUNCATE_TOOLTIP_THRESHOLD;
    },
  },
};
</script>

<style lang="scss" scoped>
.noneditable-value {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  font-size: 11px;
  font-weight: 300;
}
</style>
